import React from 'react';
import { NumberInput, TextInput } from 'ui-toolkit';
import generateLabelToPayeeText from '../utilities/generateLabelToPayeeText';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IHasMetaDataModalProps from './IHasMetaDataModalProps';
import IHasMetaDataModalState from './IHasMetaDataModalState';
import { IItemWithoutShowSellerProps } from './IItemProps';
import PurchaseItemMetaDataModal, { IPurchaseItemMetaDataModalRef } from './PurchaseItemMetaDataModal';
import SharedPurchaseItemCells from './SharedPurchaseItemCells';
import './_ModalPurchasePresentationItem.scss';
import { IBuyerReimbursementToThirdPartyViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

export interface IBuyerReimbursementToThirdPartyProps
  extends IItemWithoutShowSellerProps,
    IHasItemDataProps<IBuyerReimbursementToThirdPartyViewItem>,
    IHasItemEventProps<IBuyerReimbursementToThirdPartyViewItem>,
    IHasMetaDataModalProps {
  onFocus?: () => void;
  onBlur?: (event: React.FocusEvent) => void;
}

type IBuyerReimbursementToThirdPartyState = IHasMetaDataModalState;

export default class BuyerReimbursementToThirdParty extends React.Component<
  IBuyerReimbursementToThirdPartyProps,
  IBuyerReimbursementToThirdPartyState
> {
  public state = { expanded: !this.props.disableAutoExpand && this.props.data.new };
  private modal = React.createRef<IPurchaseItemMetaDataModalRef>();
  private firstInput: HTMLInputElement | null = null;

  public render() {
    const { data, onChange, hasEditPermissions } = this.props;

    const generateDefaultOnChangeHandler = createOnChangeHandlerGenerator(data, onChange);
    const onBuyerAtClosingChangeEvent = generateDefaultOnChangeHandler('buyer_at_closing');
    const labelOnChangeEvent = generateDefaultOnChangeHandler('label');
    const payeeOnChangeEvent = generateDefaultOnChangeHandler('payee');

    return (
      <SharedPurchaseItemCells
        {...this.props}
        buyerAtClosingDisplay="text"
        className="modal-purchase-presentation-item"
        onBlur={this.onBlur}
        onFocus={this.onFocus}
        hasEditPermissions={hasEditPermissions}
      >
        <PurchaseItemMetaDataModal
          label={generateLabelToPayeeText(data.label, data.payee)}
          expanded={this.state.expanded}
          expandedLabel={
            <div className="modal-purchase-presentation-item__expanded-label">
              <TextInput
                label={'Name'}
                onChange={labelOnChangeEvent}
                placeholder="Name"
                getInputRef={this.setFirstInput}
                value={data.label}
                readOnly={!hasEditPermissions}
                debounceOnValueChange
              />
              <span>&nbsp;to&nbsp;</span>
              <TextInput
                label={'Payee'}
                onChange={payeeOnChangeEvent}
                placeholder="Payee"
                value={data.payee}
                readOnly={!hasEditPermissions}
                debounceOnValueChange
              />
            </div>
          }
          hideBorder={true}
          onToggle={this.onModalToggleEvent}
          ref={this.modal}
        >
          <div>
            <NumberInput
              mode="currency"
              label="Amount"
              onBlur={this.onBlur}
              onFocus={this.onFocus}
              onChange={onBuyerAtClosingChangeEvent}
              value={data.buyer_at_closing}
              readOnly={!hasEditPermissions}
              debounceOnValueChange
            />
          </div>
        </PurchaseItemMetaDataModal>
      </SharedPurchaseItemCells>
    );
  }
  private setFirstInput = (element: HTMLInputElement) => {
    this.firstInput = element;
  };

  private onBlur = (event: React.FocusEvent) => {
    const { onBlur } = this.props;
    const node = this.modal.current;
    if (node && event.relatedTarget && !node.modalContains(event.relatedTarget as HTMLElement)) {
      this.setState({
        expanded: false,
      });
    }
    if (onBlur) {
      onBlur(event);
    }
  };

  private onFocus = () => {
    const { onFocus } = this.props;
    if (onFocus) {
      onFocus();
    }
  };

  private onModalToggleEvent = (expanded: boolean) => {
    this.setState({ expanded });
    if (this.firstInput) {
      this.firstInput.focus();
    }
  };
}
